import styled from '@emotion/styled';
import React from 'react';

const Container = styled.div`
  width: 100%;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;

  @media (min-width: 1024px) {
    padding-bottom: 50px;
    justify-content: flex-start;
    padding-left: 130px;
    padding-right: 100px;
  }
`;

const FaleComSuporteLink = styled.a`
  color: #0083e6;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
`;

const Footer = () => (
  <Container>
    <FaleComSuporteLink href="https://wa.me/554430136078" target="_blank">
      Fale com o Suporte KM Mídia
    </FaleComSuporteLink>
  </Container>
);

export default Footer;
